const fromStoreByIdQueryToStore = (data)=>{
    if (!data) {
        return null;
    }
    const { town , streetName , name , postalCode , additionalStreetInfo , streetNumber , code , globalStoreId ,  } = data;
    return {
        globalStoreId,
        town,
        streetName,
        name,
        code,
        postalCode: postalCode ? postalCode : undefined,
        additionalStreetInfo: additionalStreetInfo ? additionalStreetInfo : undefined,
        streetNumber: streetNumber ? streetNumber : undefined
    };
};

export { fromStoreByIdQueryToStore };
//# sourceMappingURL=fromStoreByIdQueryToStore.js.map
